@if (viewHelper && viewHelper.hasNextPage() && (!hideOnElements || (hideOnElements && viewHelper.loadedEntities < hideOnElements))) {
  @if (showPager && viewHelper.loadedEntities !== 0) {
    <p class="pager-text">{{"LOAD_MORE.INFO" | translate:{total: viewHelper.totalEntities, loaded: viewHelper.loadedEntities} }}</p>
    <div class="pager">
      <!-- pagerArray is an Array<boolean>, one entry per page, so the value is not an identity:
           tracking it collapses every unloaded page onto the same key (NG0955). The position in
           the array is the identity here. -->
      @for (pagerItemState of viewHelper.pagerArray; track $index) {
        <div class="pager__item" [ngClass]="{'pager__item--active': pagerItemState}" ></div>
      }
    </div>
  }
  <div class="button__wrapper" tabindex="0" (click)="viewHelper.loadNextPage()" [ngClass]="{disabled: viewHelper.state === viewHelperViewState.LOADING}" >
    @if (viewHelper.state === viewHelperViewState.DEFAULT && (viewHelper.totalEntities - viewHelper.loadedEntities) !== 1) {
      {{label | translate:{count: (viewHelper.totalEntities - viewHelper.loadedEntities) > viewHelper.entriesPerPage ? viewHelper.entriesPerPage : (viewHelper.totalEntities - viewHelper.loadedEntities)} }}
    }
    @if (viewHelper.state === viewHelperViewState.DEFAULT && (viewHelper.totalEntities - viewHelper.loadedEntities) === 1) {
      {{labelSingular | translate }}
    }
    @if (viewHelper.state === viewHelperViewState.LOADING) {
      {{labelLoading | translate}}
    }
  </div>
}
